import { CoreModule } from '@abp/ng.core';
import { registerLocale } from '@abp/ng.core/locale';
import { SettingManagementConfigModule } from '@abp/ng.setting-management/config';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrokerPortalConfigModule } from '@broker-portal/config';
import { CommercialUiConfigModule } from '@volo/abp.commercial.ng.ui/config';
import { AccountAdminConfigModule } from '@volo/abp.ng.account/admin/config';
import { AccountPublicConfigModule } from '@volo/abp.ng.account/public/config';
import { IdentityConfigModule } from '@volo/abp.ng.identity/config';
import { SaasConfigModule } from '@volo/abp.ng.saas/config';
import { ThemeLeptonModule } from '@volo/abp.ng.theme.lepton';
import { EnvServiceProvider } from '../environments/env.service.provider';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NhNavItemsModule } from './nh-nav-items/nh-nav-items.module';
import { APP_ROUTE_PROVIDER } from './route.provider';
import { BrandingConfigService, initializeBranding } from './service/branding-config.service';
import { GridModule } from '@progress/kendo-angular-grid';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';






@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule.forRoot({
      environment,
      registerLocaleFn: registerLocale(),
      sendNullsAsQueryParam: false,
      skipGetAppConfiguration: false,
    }),
    ThemeSharedModule.forRoot(),
    //AccountAdminConfigModule.forRoot(),
    //AccountPublicConfigModule.forRoot(),
    //IdentityConfigModule.forRoot(),
    BrokerPortalConfigModule.forRoot(),
    SaasConfigModule.forRoot(),
    SettingManagementConfigModule.forRoot(),
    ThemeLeptonModule.forRoot(),
    CommercialUiConfigModule.forRoot(),
    NhNavItemsModule,
    GridModule,
    NavigationModule,
    ButtonsModule,
    ExcelExportModule,
    ProgressBarModule,
  ],
  providers: [APP_ROUTE_PROVIDER,
    BrandingConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeBranding,
      deps: [BrandingConfigService],
      multi: true
    }, EnvServiceProvider],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
